import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { customStyles } from '~/Styles/reactSelectStyles';
import * as api from '~/Services/Service';

const SelectConta = ({ value, onChange, geSelecionada, disabled }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let ativo = true;
    if (!geSelecionada) {
      setOptions([]);
      onChange(null);
      return () => {
        ativo = false;
      };
    }

    setLoading(true);
    api
      .listarContasAutorizaDespesa(geSelecionada)
      .then((res) => {
        if (!ativo) return;
        setOptions(res || []);
      })
      .catch((err) => {
        if (!ativo) return;
        setOptions([]);
        toast.error(
          err && err.message ? err.message : 'Falha ao carregar contas.'
        );
      })
      .finally(() => {
        if (!ativo) return;
        setLoading(false);
      });
    return () => {
      ativo = false;
    };
  }, [geSelecionada]);

  const opts = options.map((c) => ({
    value: c.codigo_conta,
    label: `${c.codigo_conta} - ${c.nome || c.apelido || ''}`,
  }));

  return (
    <Select
      styles={customStyles}
      options={opts}
      value={opts.find((o) => o.value === value) || null}
      onChange={(opt) => onChange(opt ? opt.value : null)}
      isDisabled={disabled || loading || !geSelecionada}
      isClearable
      isLoading={loading}
      placeholder="Conta"
      noOptionsMessage={() => 'Nenhuma conta encontrada'}
    />
  );
};

export default SelectConta;
